import { Link } from 'react-router-dom';

const testimonials = [
  {
    text: 'Poignée de baie vitrée cassée dans mon appartement du Front de Seine. DF PRO est intervenu en 24h, pièce changée sur place. Impeccable.',
    author: 'Résident — Beaugrenelle',
    rating: 5,
  },
  {
    text: 'Volet roulant bloqué en position fermée, sangle cassée. Le technicien a tout remis en état en moins d\'une heure. Prix conforme au devis.',
    author: 'Propriétaire — Vaugirard',
    rating: 5,
  },
  {
    text: 'Crémone ancienne sur fenêtre bois haussmannienne introuvable. Ils ont adapté une pièce moderne. Travail soigné, je recommande.',
    author: 'Syndic de copropriété — Grenelle',
    rating: 5,
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-14 md:py-20 bg-[#e6f7f5]">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <p className="text-xs md:text-sm text-brand-accent font-medium mb-3 flex items-center justify-center gap-2">
            <span className="w-2 h-2 rounded-full bg-brand-accent"></span>
            Ils nous font confiance
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-brand-dark font-heading">
            4.9/5 · Avis des habitants du 15ᵉ
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, idx) => (
            <div key={idx} className="bg-white rounded-2xl p-6 md:p-8 border border-brand-mint/60 flex flex-col shadow-sm">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full bg-brand-mint flex items-center justify-center flex-shrink-0 text-brand-accent font-bold text-lg">
                  {t.author.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-semibold text-brand-dark">{t.author}</p>
                  <p className="text-xs text-brand-text/50">Google · {t.rating} étoiles</p>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
              </div>
              <p className="text-sm md:text-base text-brand-text/70 leading-relaxed italic">
                &ldquo;{t.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}